import { render, staticRenderFns } from "./OurProjects.vue?vue&type=template&id=4e3c4f4d&scoped=true"
import script from "./OurProjects.vue?vue&type=script&lang=js"
export * from "./OurProjects.vue?vue&type=script&lang=js"
import style0 from "./OurProjects.vue?vue&type=style&index=0&id=4e3c4f4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c4f4d",
  null
  
)

export default component.exports